import { Component, Input, OnInit } from '@angular/core';

import { Package } from '@features/opportunities/models/product-selection/product-selection.model';

@Component({
  selector: 'app-product-selection-package',
  templateUrl: './package.component.html',
  styleUrls: ['./package.component.scss']
})
export class ProductSelectionPackageComponent implements OnInit {

  @Input()
  package!: Package;

  public get totalRepayments() : number {
    return this.package.products
      .map(packageProduct => packageProduct.product.totalRepayments)
      .reduce((totalRepayments, repayments) => totalRepayments + repayments, 0);
  } 

  ngOnInit(): void { }
}
